import type {
  ReportSeverity,
  ReportSeverityKey,
  ReportSeverityResults,
} from '../report';
import type { Filters } from '../table/filters';

export type ColorFilterStatus = -1 | 0 | 1 | 2;
type Checks = Partial<Record<ReportSeverityKey, Filters>>;
type Descriptions = {
  general?: string;
  checks?: Partial<Record<ReportSeverityKey, string>>;
};
type Group = { id: string };

type Result = {
  checks: Partial<ReportSeverityResults>;
  count: number;
};

type TranslatedColorFilterStatus = 'error' | 'run' | 'done' | 'notComputed';
export const COLOR_FILTERS_STATUS: Record<
  TranslatedColorFilterStatus,
  ColorFilterStatus
> = {
  error: -1,
  run: 0,
  done: 1,
  notComputed: 2,
};

export type ReportData = {
  id: string;
  apiEndpoint: string;
  checks: Checks;
  column: string;
  custom: boolean;
  descriptions: Descriptions;
  result: Result;
  defaultColor: ReportSeverity | null;
  name: string;
  status: ColorFilterStatus;
  groups: Group[];
};

export type ReportsResponseBody = ReportData[];

export type ReportGroupChild = {
  id: string;
  weight: number;
};

export type ReportGroupData = {
  children: ReportGroupChild[];
  custom: boolean;
  id: string;
  name: string;
};

export type ReportGroupsResponseBody = ReportGroupData[];
